import React, { useEffect, Fragment, useState } from "react";
import { Tabs, TabList, TabPanel, Tab } from "react-tabs";
import Breadcrumb from "../common/breadcrumb";
import { User, Layers } from "react-feather";
import { Container, Col, Row, Card, CardBody } from "reactstrap";
import UserTransactions from "./userTransaction";
import DeleteConfirmPopup from "../common/deleteConfirmPopup";
import { useDispatch, useSelector } from "react-redux";
import { queryString } from "./../../utils/queryString";
import Userinventory from "./user-inventory";
import {
  getloginHistoryData,
  getUserDetailById,
} from "../../reducers/adminReducers";
import placeholder from "../../assets/images/fashion/product/12.jpg";
import { adminInstance } from "../../config/axios";
import { toast } from "react-toastify";
import Loader from "../loader/loader";
import UserSkinTransactions from "./userSkinTrransaction";
import { RustyRoyalCoin } from "../../utils/SvgIcons";
import { formatDateTime } from "../../utils/multiuseFunctions";
const UserProfileDetails = () => {
  const result = useSelector((state) => state.admin);
  const {
    userData,
    userTransactions,
    userinventoryList,
    skinWithdrawTransactions,
    skinDepositTransactions,
  } = result || {};
  const dispatch = useDispatch();
  const { id: userId } = queryString();
  const [open, setOpen] = useState(false);
  const [activeId, setActiveId] = useState();
  const [loading, setLoading] = useState(false);
  // const [kycStatus, setKycStatus] = useState("Pending");
  // console.log("skinWithdrawTransactions====>", skinWithdrawTransactions);
  // console.log("skinDepositTransactions===>", skinDepositTransactions);
  useEffect(() => {
    async function getData() {
      setLoading(true);
      await dispatch(getloginHistoryData(userId));
      const res1 = await dispatch(getUserDetailById(userId));
      if (res1) setLoading(false);
    }
    getData();
  }, [dispatch, userId]);
  const handleOnDelete = async (id) => {
    try {
      const response = await adminInstance().delete(
        `api/admin/deleteBackPackInventory/${id}/${userId}`
      );
      const { code } = response.data;
      if (code === 200) {
        toast.success("Successfully Deleted");
        dispatch(getUserDetailById(userId));
      }
      setOpen(false);
    } catch (error) {}
  };
  const onCloseModal = () => {
    setOpen(false);
  };

  // useEffect(() => {
  //   if (userData && userData?.kycStatus === true) {
  //     setKycStatus("Completed");
  //   } else {
  //     setKycStatus("Pending");
  //   }
  // }, [userData]);
  return (
    <Fragment>
      {loading && <Loader />}
      <Breadcrumb title="User Profile Details" parent="Settings" />
      <Container fluid={true}>
        <Row>
          <Col xl="12">
            <Card className="profile-card user__profile__card">
              <CardBody>
                <div>
                  <Tabs>
                    <TabList className="nav nav-tabs tab-coupon">
                      <Tab className="nav-link">
                        <User className="mr-2" />
                        Profile
                      </Tab>
                      <Tab className="nav-link">
                        <div className="d-flex m-0" style={{}}>
                          <RustyRoyalCoin size={16} />{" "}
                          <div className="pl-1"> Transactions</div>
                        </div>
                      </Tab>
                      <Tab className="nav-link">
                        <Layers className="mr-2" />
                        Inventory
                      </Tab>
                      <Tab className="nav-link">
                        <Layers className="mr-2" />
                        Skin Deposit
                      </Tab>
                      <Tab className="nav-link">
                        <Layers className="mr-2" />
                        Skin Withdraw
                      </Tab>
                    </TabList>

                    <TabPanel>
                      <section
                        className="section about-section gray-bg"
                        id="about">
                        <div className="container">
                          <h3
                            className="dark-color mb-3"
                            style={{
                              fontWeight: "700",
                            }}>
                            User Info
                          </h3>
                          <div className="row align-items-center justify-content-end flex-row-reverse mb-3">
                            <div className="col-lg-8">
                              <div className="about-text go-to">
                                <div className="row about-list">
                                  <div className="col-md-6">
                                    <div className="media">
                                      <label>First Name</label>
                                      <p>{userData?.firstname || ""}</p>
                                    </div>
                                    <div className="media">
                                      <label>Last Name</label>
                                      <p>{userData?.lastname || ""}</p>
                                    </div>
                                    <div className="media">
                                      <label>Email</label>
                                      <p>{userData?.email || "N/A"}</p>
                                    </div>
                                    <div className="media">
                                      <label>User Type</label>
                                      <p>{userData?.userType || ""}</p>
                                    </div>
                                    <div className="media">
                                      <label>SteamId</label>
                                      <p>{userData?.steamId || ""}</p>
                                    </div>
                                    {/* <div className="media">
                                      <label>Country</label>
                                      <p>{userData?.country || "N/A"}</p>
                                    </div> */}
                                  </div>
                                  <div className="col-md-6">
                                    <div className="media">
                                      <label>Username</label>
                                      <p>{userData?.username || ""}</p>
                                    </div>
                                    <div className="media">
                                      <label>User Joined</label>
                                      <p>
                                        {formatDateTime(userData?.joined_at) ||
                                          ""}
                                      </p>
                                    </div>

                                    {/* <div className="media">
                                      <label>Mobile No</label>
                                      <p>{userData?.mobile || ""}</p>
                                    </div> */}
                                    <div className="media">
                                      <label> Ref. Code</label>
                                      <p>{userData?.referralCode || "N/A"}</p>
                                    </div>
                                    <div className="media">
                                      <label> Ref. Count</label>
                                      <p>{userData?.referalCount || 0}</p>
                                    </div>
                                    {/* <div className="media">
                                      <label>Mobile No</label>
                                      <p>{userData?.mobile || ""}</p>
                                    </div> */}
                                    {/* <div className="media">
                                      <label>DOB</label>
                                      <p>
                                        {userData?.dateOfBirth?.substr(0, 10) ||
                                          ""}
                                      </p>
                                    </div> */}
                                    {/* <div className="media">
                                      <label>KYC Status</label>
                                      <p>{kycStatus}</p>
                                    </div> */}
                                    {}
                                  </div>
                                  {userData?.blockReason && (
                                    <div className="col-md-12 pt-4">
                                      <p>
                                        <b>Block Reason :</b> {userData?.blockReason}
                                      </p>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-3">
                              <div className="about-avatar mx-0">
                                <img
                                  src={userData?.profile || placeholder}
                                  title=""
                                  alt=""
                                />
                              </div>
                            </div>
                          </div>
                          <div className="">
                            <div className="row">
                              <div className="col-6 col-lg-4 counter mx-2">
                                <div className="count-data text-center border_total">
                                  <h6
                                    className="count h2 d-flex justify-content-center align-items-center m-0"
                                    data-to="500"
                                    data-speed="500">
                                    <span
                                      className=""
                                      style={{ marginBottom: "12px" }}>
                                      <RustyRoyalCoin size={28} />
                                    </span>{" "}
                                    <div className="pl-1 m-0">
                                      {" "}
                                      {(userData?.totalDeposit || 0).toFixed(2)}
                                    </div>
                                  </h6>
                                  <p className="m-0px font-w-500">
                                    Total Deposit
                                  </p>
                                </div>
                              </div>
                              <div className="col-6 col-lg-4 counter mx-2">
                                <div className="count-data text-center">
                                  <h6
                                    className="count h2 d-flex justify-content-center align-items-center m-0"
                                    data-to="150"
                                    data-speed="150">
                                    <span
                                      className=""
                                      style={{ marginBottom: "12px" }}>
                                      <RustyRoyalCoin size={28} />
                                    </span>{" "}
                                    <div className="pl-1 m-0">
                                      {" "}
                                      {userData?.walletAmount?.toFixed(2) ||
                                        "0.00"}{" "}
                                    </div>
                                  </h6>
                                  <p className="m-0px font-w-500">
                                    Current Balance
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>
                    </TabPanel>
                    <TabPanel>
                      <div id="batchDelete" className="transactions">
                        <UserTransactions
                          multiSelectOption={false}
                          myData={userTransactions}
                          pageSize={10}
                          pagination={true}
                          className="-striped -highlight"
                        />
                      </div>
                    </TabPanel>
                    <TabPanel>
                      <div id="batchDelete" className="transactions">
                        <Userinventory
                          multiSelectOption={false}
                          myData={userinventoryList}
                          pageSize={10}
                          pagination={true}
                          className="-striped -highlight"
                          setOpen={setOpen}
                          setActiveId={setActiveId}
                          id={userId}
                        />
                      </div>
                    </TabPanel>
                    <TabPanel>
                      <div id="batchDelete" className="transactions">
                        <UserSkinTransactions
                          multiSelectOption={false}
                          myData={skinDepositTransactions}
                          pageSize={10}
                          pagination={true}
                          className="-striped -highlight"
                          setOpen={setOpen}
                          setActiveId={setActiveId}
                          id={userId}
                        />
                      </div>
                    </TabPanel>
                    <TabPanel>
                      <div id="batchDelete" className="transactions">
                        <UserSkinTransactions
                          multiSelectOption={false}
                          myData={skinWithdrawTransactions}
                          pageSize={10}
                          pagination={true}
                          className="-striped -highlight"
                          setOpen={setOpen}
                          setActiveId={setActiveId}
                          id={userId}
                        />
                      </div>
                    </TabPanel>
                  </Tabs>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
      <DeleteConfirmPopup
        title={"Delete User"}
        open={open}
        handleOnDelete={handleOnDelete}
        onCloseModal={onCloseModal}
        id={activeId}
      />
    </Fragment>
  );
};

export default UserProfileDetails;
